import { createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "../utils/config";

const initialState = {
  mainCategoryList: [],
  subCategoriesList: [],
  products: [],
};

const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    mainCategoryList: (state, action) => {
      state.mainCategoryList = action.payload;
    },
    subCategoryList: (state, action) => {
      state.subCategoriesList = action.payload;
    },
    productsList: (state, action) => {
      state.products = action.payload;
    },
  },
});
export const { mainCategoryList, subCategoryList, productsList } =
  productSlice.actions;

export const getCategoryList = (pageNumber,size) => (dispatch) => {
  fetch(BASE_URL, {
    method: "POST",
    body: JSON.stringify({
      action: "getBrandMainCategories",
      src: "dashboard",
      retrievalmode: "",
      page: pageNumber,
      size: size,
    }),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
  })
    .then((response) => response.json())
    .then((response) => {
      dispatch(mainCategoryList(response))
    })
    .catch((err) => {
      console.log(err.message);
    });
};

export const getSubCategoryList = async (pageNumber,size) => {
  return fetch(BASE_URL, {
    method: "POST",
    body: JSON.stringify({
      action: "getBrandSubCategories",
      src: "dashboard",
      retrievalmode: "",
      page: pageNumber,
      size: size,
    }),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
  })
    .then((response) => response.json())
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err.message);
    });
};

export const getProductsList = async (pageNumber,size) => {
  return fetch(BASE_URL, {
    method: "POST",
    body: JSON.stringify({
      action: "getProductList",
      src: "dashboard",
      brandid: 0,
      categoryid: 0,
      retrievalmode: "",
      page: pageNumber,
      size: size,
    }),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
  })
    .then((response) => response.json())
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err.message);
    });
};

export const getSizesList = async (pageNumber,size) => {
  return fetch(BASE_URL, {
    method: "POST",
    body: JSON.stringify({
      action: "getProductSizes",
      src: "dashboard",
      retrievalmode: "",
      page: pageNumber,
      size: size,
    }),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
  })
    .then((response) => response.json())
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err.message);
    });
};

export const getColorsList = async (pageNumber,size) => {
  return fetch(BASE_URL, {
    method: "POST",
    body: JSON.stringify({
      action: "getProductColors",
      src: "dashboard",
      retrievalmode: "",
      page: pageNumber,
      size: size,
    }),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
  })
    .then((response) => response.json())
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err.message);
    });
};

export default productSlice.reducer;
